import * as React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { makeResetCache, notify } from 'gossamer-front-end';

export interface ActionButtonProps {
  error?: boolean;
  onError?: (e: unknown) => void;
  execute: (resetCache: (entityId: string, key?: string) => void) => Promise<void>;
  label: string;
  size?: 'sm' | 'lg';
  variant?: string;
  waiting?: boolean;
}

export const ActionButton = (props: ActionButtonProps): React.JSX.Element => {
  const dispatch = useDispatch();
  const [processing, setProcessing] = React.useState<boolean>(false);
  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation(); // prevent event propagating to elements behind
    event.preventDefault(); // prevent browser default behaviour
    if (processing || props.waiting) {
      return;
    }
    try {
      setProcessing(true);
      const resetCache = makeResetCache(dispatch);
      await props.execute(resetCache);
    } catch (e) {
      if (props.onError) {
        props.onError(e);
      } else {
        console.error(e);
        notify(['an error occurred, please try again later', 'danger']);
      }
    }
    setProcessing(false);
  };
  return (
    <Button size={props.size || 'sm'} variant={props.variant || 'primary'} onClick={handleClick}>
      {(processing || props.waiting) && (
        <>
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
          &nbsp;&nbsp;
        </>
      )}
      {props.error && <>⚠&nbsp;&nbsp;</>}
      {props.label}
    </Button>
  );
};
